'use client';

import type { ReactNode } from 'react';
import { LiquidGlass } from '@/components/ui/liquid-glass/LiquidGlass';
import { cn } from '@/lib/cn';
import styles from './CreationGlassSurface.module.css';

/** Actual homepage lens for tool chrome; guest homepage previews can retain their original DOM. */
export function CreationGlassSurface({ children, className, enabled = true }: { children: ReactNode; className?: string; enabled?: boolean }) {
  if (!enabled) return <>{children}</>;
  return <LiquidGlass className={cn(styles.surface, className)}>{children}</LiquidGlass>;
}
